export default () => {
  return (
    <div className="flex items-center justify-center">
      <div className="w-5 h-5 border-4 border-blue-500 border-t-transparent border-solid rounded-full animate-spin mx-10 my-1"></div>
    </div>
  );
};

